module.exports = __webpack_public_path__ + "img/opet-infographic-04.2879aeaa.jpg";